<template>
    <div class="flex h-auto bg-gray-900 text-white">
      <!-- Sidebar -->
      <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg">
        <div class="flex items-center justify-center space-x-3">
       <img src="@/assets/logo.svg" alt="Syniac Logo" class="h-20">
        </div>
        <Navbar></Navbar>
      </aside>
  
      <div class="flex-1 flex flex-col">
        <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md">
          <h2 class="text-xl font-semibold">Pending Network Requests</h2>
        </header>
  
        <main class="p-6 flex-1">
          <div class="bg-gray-800 p-6 rounded-xl shadow-md">
            <h3 class="text-lg font-semibold mb-4">Pending Approvals</h3>
  
            <table class="w-full text-left border-collapse">
              <thead>
                <tr class="bg-gray-700">
                  <th class="p-3">Type</th>
                  <th class="p-3">Value</th>
                  <th class="p-3">User</th>
                  <th class="p-3">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="request in pendingRequests" :key="request.id" class="border-b border-gray-600">
                  <td class="p-3">{{ request.type || "N/A" }}</td>
                  <td class="p-3">{{ request.value }}</td>
                  <td class="p-3">{{ request.user_id }}</td>
                  <td class="p-3 flex space-x-2">
                    <button @click="approveRequest(request.id)" class="px-4 py-2 bg-green-500 text-white rounded">Approve</button>
                    <button @click="denyRequest(request.id)" class="px-4 py-2 bg-red-500 text-white rounded">Deny</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from '@/components/adminnav.vue';
  import axios from 'axios';
  
  export default {
    name: "AdminNetwork",
    data() {
      return { pendingRequests: [] };
    },
    methods: {
      async fetchPendingRequests() {
        try {
          const res = await axios.get('https://api.syniac.com:3000/api/admin/network/pending-network', { withCredentials: true });
          this.pendingRequests = res.data;
        } catch (error) {
          console.error("Error fetching pending requests:", error);
        }
      },
      async approveRequest(id) {
        try {
          await axios.post(`https://api.syniac.com:3000/api/admin/network/${id}/approve`, {}, { withCredentials: true });
          this.pendingRequests = this.pendingRequests.filter(req => req.id !== id);
        } catch (error) {
          console.error("Error approving request:", error);
        }
      },
      async denyRequest(id) {
        try {
          await axios.post(`https://api.syniac.com:3000/api/admin/network/${id}/deny`, {}, { withCredentials: true });
          this.pendingRequests = this.pendingRequests.filter(req => req.id !== id);
        } catch (error) {
          console.error("Error denying request:", error);
        }
      }
    },
    mounted() {
      this.fetchPendingRequests();
    },
    components: { Navbar }
  };
  </script>
  
